export const getTotalFixedCostYear1 = (value) => {
    return {
      type: "GET_TOTAL_FIXED_COST_YEAR_1",
      payload: value,
    };
  };
  export const getTotalFixedCostYear2 = (value) => {
    return {
      type: "GET_TOTAL_FIXED_COST_YEAR_2",
      payload: value,
    };
  };
  export const getTotalFixedCostYear3 = (value) => {
    return {
      type: "GET_TOTAL_FIXED_COST_YEAR_3",
      payload: value,
    };
  };
  